<div>
    <div style="margin: 20px 20px;">
        <span>LSO Acknowledgement</span>
    </div>
    <div style="margin: 20px 20px;">
        <owc-input [label]="'Comments'" value="" [formControl]="commentText" style="width: 100%; ">
        </owc-input>
        <div style="margin-top: 20px;">
            <h4>Attachment (maximum size: 15 MB):</h4>
            <dl-file-upload-single [ackFileFlag]="false"></dl-file-upload-single>
        </div>
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 12px; margin: 20px;">
        <owc-button class="cancel-button" title="Cancel" (click)="cancel()">Cancel</owc-button>
        <owc-button color="primary" title="Acknowledge" [disabled]="!commentText.value"
            (click)="sendAckDetails()">Acknowledge</owc-button>
    </div>
</div>
<!-- Notice Dialog Modal -->
<owc-modal-dialog [(ngModel)]="visibleLsoacknowledgement" size="small">
  <dl-lsoacknowledgement-notice (onClose)="onNoticeDialogClose($event)"></dl-lsoacknowledgement-notice>
</owc-modal-dialog>